<div #outsideModal class="modal">
    <div #modalBody class="modal-content">
      <div class="modal-header">Scanner de Code-barres / Datamatrix / QRCode</div>
      <div class="modal-body">
        <div class="scanner-shell" [hidden]="!hasDevices || loading === true">
          <mat-form-field appearance="fill">
            <mat-select [value]="deviceSelected" (selectionChange)="onInputTypeChange($event.value)">
              <mat-option value="camera">Caméra</mat-option>
              <mat-option value="scanner">Lecteur QR Code</mat-option>
            </mat-select>
            <mat-label><mat-icon>videocam</mat-icon> <b>Type de périphérique</b></mat-label>
          </mat-form-field>
          <div class="video-wrapper" *ngIf="deviceSelected === 'camera'">
            <zxing-scanner 
              [formats]="['QR_CODE', 'EAN_13', 'CODE_128', 'DATA_MATRIX']"
              [device]="deviceCurrent"
              (deviceChange)="onDeviceChange($event)"
              (camerasFound)="camerasFoundHandler($event)"
              (camerasNotFound)="camerasNotFoundHandler($event)"
              (permissionResponse)="onHasPermission($event)"
              (scanSuccess)="scanSuccessHandler($event)"
              (scanError)="scanErrorHandler($event)"
              (scanFailure)="scanFailureHandler($event)"
              (scanComplete)="scanCompleteHandler($event)"
            ></zxing-scanner>
            <div class="loader-wrapper" *ngIf="deviceSelected === 'camera' && videoLoading">
              <div class="lds-spinner">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          </div>
          <div *ngIf="deviceSelected === 'scanner' && !loading && !scanActive" class="qr-scanner-wrapper">
            <p>Scannez un code QR avec le lecteur.</p>
            <p>Si vous n'avez pas de lecteur, veuillez vous servir de la caméra, et choisir "Caméra" dans les Types de
              périphériques.</p>
            <frg-button *ngIf="!loading && isPortUsb" (activated)="startScannerInput()"
              [backgroundColor]="'var(--darkest-primary)'">
              Commencer le scan</frg-button>
            <frg-button *ngIf="!loading && isPortCom" (activated)="handlePortComEvent()"
              [backgroundColor]="'var(--darkest-primary)'">
              Lancer le lecteur</frg-button>
          </div>
          <div *ngIf="scanActive && deviceSelected === 'scanner'" class="scan-indicator">
            <div class="scan-title">
              <div class="scan-pulse"></div>
              <h3> Scan activé</h3>
            </div>
            <div class="scan-text">
              <p>Passez le QR Code devant le lecteur</p>
            </div>
          </div>
        </div>
        <div class="loader-wrapper" *ngIf="loading === true">
          <div>Recherche en cours...</div>
          <div class="lds-spinner">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        <ng-container *ngIf="deviceSelected === 'camera' && videoLoading === false">
          <ng-container *ngIf="hasPermission === undefined">
            <p>Demande de permission en cours.</p>
          </ng-container>
          <ng-container *ngIf="hasPermission === false">
            <p>Nous n'avons pas la permission d'utiliser les caméras.</p>
          </ng-container>
          <ng-container *ngIf="hasDevices === undefined">
            <p>Impossible de vérifier les caméras présentes.</p>
            <p>
              Cela peut être causé par des directives de sécurité du navigateur/ordinateur.
            </p>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="hasDevices === false ">
            <p>Aucun périphérique trouvé.</p>
            <p>
              Vérifier qu'une caméra ou un lecteur de QR Code est bien présent dans l'ordinateur.
            </p>
          </ng-container>
        <div class="button-wrapper">
          <frg-button (activated)="closeModal()" [backgroundColor]="'var(--darkest-primary)'">
              Fermer</frg-button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-background"></div>
